import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Field } from 'redux-form'
import Mixin from 'components/common/Mixin'
import Text from 'components/common/Text/Text'
import { Input } from 'components/common/FormElements/Input'
import Media from 'components/common/Media'

const ResultsPageListHeader = ({ handleFilterChange, searchSummary, viewModel }) =>
  <Sort>
    <Summary data-at-results-header-summary>{ searchSummary }</Summary>
    <Field
      { ...viewModel.sort }
      component={ Input }
      full="mobile"
      width="288px"
      onChange={ handleFilterChange } />
  </Sort>

export default ResultsPageListHeader

ResultsPageListHeader.propTypes = {
  handleFilterChange: PropTypes.func,
  searchSummary: PropTypes.string,
  viewModel: PropTypes.shape({
    sort: PropTypes.object
  })
}

const Sort = styled.div`
  margin-bottom: 40px;
  ${Mixin.clearFix()}
`

const Summary = styled(Text)`
  display: block;
  margin: 10px 0;
  font-size: 22px;
  letter-spacing: -0.5px;
  overflow: hidden;
  text-overflow: ellipsis;
  ${Mixin.responsive('padding-bottom', '20px', '10px')}
  ${Media.desktop`
    float: right;
    max-width: 400px;
    margin: 0;
    font-size: 24px;
  `}
`
